import { render, staticRenderFns } from "./MyKPI.vue?vue&type=template&id=908798ca&"
import script from "./MyKPI.vue?vue&type=script&lang=js&"
export * from "./MyKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports